import Chip, {chipClasses} from "@mui/material/Chip";
import {FC} from "react";

interface WriteStatusProps {
    writeStatus: string;
    writeStatusId: number;
}

export const WriteStatus: FC<WriteStatusProps> = ({writeStatus, writeStatusId,}) => {
    let color: string = ''
    if (writeStatusId == 3) {
        color = "#DDDDDD"
    } else if (writeStatusId == 2) {
        color = "#FF8282"
    } else if (writeStatusId == 1) {
        color = '#A0C878'
    }
    return <Chip size={'medium'} sx={{backgroundColor: color, border: 'none', [`& .${chipClasses.label}`]: {fontWeight: 400, color: '#000'}}} label={writeStatus || "-"}
                 variant={'filled'}/>
}